import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
// import "./EventDetails.css"; 
import axios from "axios";

const EventDetailsViewGuest = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [eventDocs, setEventDocs] = useState([]);

  useEffect(() => {
    fetchEventDetails();
  }, []);

  const fetchEventDetails = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/events/${id}`);
    setEvent(response.data);
    setEventDocs(Array.isArray(response.data.attachments) ? response.data.attachments : []);

  } catch (error) {
    console.error("Error fetching event details:", error);
  } finally {
    setLoading(false);
  }
  };


  if (loading) {
    return (
      <div className="loading-container">
        <CircularProgress />
        <p>Loading event details.</p>
      </div>
    );
  }

  if (!event) {
    return <p className="error-message">Event not found</p>;
  }

  return (
    <>
        <Box className="event-wrapper">
  <Box className="back-button-container">
    <Button variant="contained" className="back-button" onClick={() => navigate(-1)}>
      BACK
    </Button>
     {/* <Button variant="contained" className="back-button" >
      Edit
    </Button> */}
  </Box>

  <Box className="event-main-layout">
    <Box className="event-left">
      {/* {event.eventImage ? (
        <img src={event.eventImage}
              alt={event.eventName}
              className="event-thumbnail"
            />
      ) : (
        <Box className="no-image"></Box>
      )} */}
    </Box>

    <Box className="event-center">
      <Typography variant="h4" className="event-title-text">{event.eventName}</Typography>
             <Typography className="event-date-text">
                    Application Deadline : {event.applicationDeadline ? new Date(event.applicationDeadline).toLocaleDateString("en-US", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric"
                      }) : "-"}
              </Typography>

      <Typography className="event-description" sx={{ mt: 2 }}>
        {event.description}
      </Typography>
    </Box>

    <Box className="event-right">
      <Typography className="meta-label">Host</Typography>
      <Typography className="meta-value">{event.hostOrganisation}</Typography>

      <Typography className="meta-label">Tag</Typography>
      <Typography className="meta-value">{event.categories?.join(", ")}</Typography>


      <Typography className="meta-label">Cost</Typography>
      <Typography className="meta-value">{event.cost}</Typography>

      {/* <Typography className="meta-label">Application Deadline</Typography>
      <Typography className="meta-value">
        {event.applicationDeadline ? new Date(event.applicationDeadline).toDateString() : "N/A"}
      </Typography> */}
      <Typography variant="subtitle1" className="meta-label">Flyer</Typography>
              {eventDocs.map((url, i) => (
                <Box key={i} sx={{ my: 2 }}>
                  {/* Preview iframe */}
                  <iframe
                    src={url}
                    title={`Preview ${i}`}
                    width="100%"
                    height="150px"
                    style={{ border: "1px solid #ccc", borderRadius: "4px" }}
                  >
                    
                  </iframe>

                  {/* Download/View link */}
                  <Box mt={1}>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                       {event.eventName}
                    </a>
                  </Box>
                </Box>
              ))}
              <Typography className="meta-label"> URL</Typography>
              <a href={event.hostURL} target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Typography className="meta-link">{event.hostURL}</Typography></a>

        { (event.mode === "Online"  || event.mode === "Hybrid")? <>
          <Typography className="meta-label">Location</Typography>
          <Typography className="meta-value">{event.mode}</Typography>

          <Typography className="meta-label">Online Meeting Link</Typography>
          <a href={event.onlineSessionLink} target="_blank"  rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
          <Typography className="meta-link">{event.onlineSessionLink}</Typography></a>

      </>: <>
      <Typography className="meta-label">Location</Typography>
      <Typography className="meta-value"> {event.mode} - {event.location}</Typography>
      </>
      }
       

    </Box>
  </Box>
</Box>
    </>
  );
};

export default EventDetailsViewGuest;
